import { transformToRailsParams } from "./railsParamsTransform.js";
import { mergeDemoInput } from "./mergeDemoInput.js";
import { getDefaultFormValues } from "../config/defaultValues.js";

// デモ入力を demo_form_data（本登録フォームの hidden field）用の JSON 文字列にする。
// mergeDemoInput で項目ごとに安全な形へ整えてから変換するため、1項目だけ型が壊れていても
// その項目だけが空欄になり、他の入力は引き継がれる（docs/demo.md 3.9）。
export const buildDemoFormData = (values) => {
  const safeValues = mergeDemoInput(values, getDefaultFormValues());
  // transformToRailsParams の戻り値からプロジェクト1件分の属性を取り出す
  const project = transformToRailsParams(safeValues).user.work_histories_attributes[0];
  return JSON.stringify(project);
};
